import '@stylus/main.styl';

import { App } from '@/app';
import router from '@/router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import '@yzfe/svgicon/lib/svgicon.css';
import { VueSvgIcon } from '@yzfe/vue-svgicon';
import Axios from 'axios';
import Vue from 'vue';

// Plugins Fael
import LeadFael from '@lib/leadFael';
import UtilsFael from '@lib/utilsFael';

Vue.config.productionTip = false
Vue.prototype.$eventbus = new Vue()
Vue.prototype.$axios = Axios.create({
	baseURL: `${process.env.VUE_APP_API_ROUTE}/api`
})

Vue.use(LeadFael, { endpoint: `${process.env.VUE_APP_API_ROUTE}/api` })
Vue.use(UtilsFael, { endpoint: `${process.env.VUE_APP_API_ROUTE}/api` })

Vue.component('SvgIcon', VueSvgIcon)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
